"use strict";
document.addEventListener("DOMContentLoaded", function() {
    var updateButtons = function updateButtons() {
        buttons.appendRow.disabled = !canAppendRow();
        buttons.removeRow.disabled = !canRemoveRow();
        buttons.appendColumn.disabled = !canAppendColumn();
        buttons.removeColumn.disabled = !canRemoveColumn();
    };
    var appendRow = function appendRow() {
        if (!canAppendRow()) return;
        var newRow = table.insertRow();
        var colCount = getColCount();
        for(var i = 0; i < colCount; i += 1)newRow.insertCell().textContent = "";
    };
    var removeRow = function removeRow() {
        if (!canRemoveRow()) return;
        table.deleteRow(getRowCount() - 1);
    };
    var appendColumn = function appendColumn() {
        if (!canAppendColumn()) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = table.rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var row = _step.value;
                row.insertCell().textContent = "";
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var removeColumn = function removeColumn() {
        if (!canRemoveColumn()) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = table.rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var row = _step.value;
                row.deleteCell(row.cells.length - 1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var table = document.querySelector(".field");
    var buttons = {
        appendRow: document.querySelector(".append-row"),
        removeRow: document.querySelector(".remove-row"),
        appendColumn: document.querySelector(".append-column"),
        removeColumn: document.querySelector(".remove-column")
    };
    var LIMITS = {
        min: 2,
        max: 10
    };
    var getRowCount = function() {
        return table.rows.length;
    };
    var getColCount = function() {
        return table.rows[0].cells.length;
    };
    var canAppendRow = function() {
        return getRowCount() < LIMITS.max;
    };
    var canRemoveRow = function() {
        return getRowCount() > LIMITS.min;
    };
    var canAppendColumn = function() {
        return getColCount() < LIMITS.max;
    };
    var canRemoveColumn = function() {
        return getColCount() > LIMITS.min;
    };
    buttons.appendRow.addEventListener("click", function() {
        appendRow();
        updateButtons();
    });
    buttons.removeRow.addEventListener("click", function() {
        removeRow();
        updateButtons();
    });
    buttons.appendColumn.addEventListener("click", function() {
        appendColumn();
        updateButtons();
    });
    buttons.removeColumn.addEventListener("click", function() {
        removeColumn();
        updateButtons();
    });
    updateButtons();
});

//# sourceMappingURL=index.4cf66d53.js.map
